export default "__VITE_ASSET__D72oCrDr__"